import { render } from "./designAddressPrint.vue?vue&type=template&id=13eb57bc"
import script from "./designAddressPrint.vue?vue&type=script&lang=js"
export * from "./designAddressPrint.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__